import DeckTitle from 'gatsby-theme-slidedeck/src/components/deckTitle';
import { default as DeckEnd } from 'gatsby-theme-slidedeck/src/components/deckTitle';
import React from 'react';
export default {
  DeckTitle,
  DeckEnd,
  React
};